/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {
  TableDefault,
  ShadowTableHead,
  StickyMainHeader,
  StickyShadowMainHeader,
  StickySubHeader,
  ArrowHolderSummary,
  ColumnContainerSummary,
  TeamAverageRow,
  ShadowSummaryColumn,
  ArrowDownContainer,
  ShadowTableColumn,
} from './styles';
import {Utils} from '../../utils/api';
import {GoChevronDown, GoChevronUp, GoArrowDown} from 'react-icons/go';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';

export default ({
  dataTableContent,
  average,
  dataCy,
  fatigueZone,
  setTableUpdated,
  hideExam,
}: {
  dataTableContent: Array<any>;
  average: any;
  dataCy?: string;
  fatigueZone?: boolean;
  setTableUpdated?: any;
  hideExam?: any;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const [loading, useLoading] = useState<boolean>(false);
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
    useLoading(false);
  }, [dataTableContent]);

  useEffect(() => {
    if (loading) {
      setTableUpdated(true);
    }
  }, [loading]);

  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortIsoDate(params, sortOptions);
  }

  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function changeStatus(change) {
    // if (change < 0) {
    //   return (
    //     <ArrowDownContainer>
    //       <GoArrowDown size="10px" color="#fff" />
    //     </ArrowDownContainer>
    //   );
    // }
    return null;
  }

  function SortingTableHead({title = '', attr, location, sortFunction}) {
    return (
      <StickySubHeader onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickySubHeader>
    );
  }
  function SortingShadowTableHead({title = '', attr, location, sortFunction}) {
    return (
      <ShadowTableHead onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </ShadowTableHead>
    );
  }

  function DownloadReport() {}

  return (
    <TableDefault data-cy={dataCy} minWidth="1200px">
      <thead>
        <tr>
          <StickyMainHeader colSpan={1}>HIDE</StickyMainHeader>
          <StickyMainHeader colSpan={1}>DATE</StickyMainHeader>
          <StickyMainHeader colSpan={2}>TOTAL PRIMER</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>ACCEL</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>DECEL</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>DECEL:ACCEL RATIO</StickyShadowMainHeader>
          <StickyMainHeader colSpan={3}>WELLNESS</StickyMainHeader>
        </tr>
        <tr>
          <StickySubHeader />
          <SortingTableHead title="Sort date" attr="date" location={['date']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Result" attr="total" location={['total']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Change" attr="totalChange" location={['totalChange']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Result" attr="accel" location={['accel']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Change" attr="changeAccel" location={['changeAccel']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Result" attr="decel" location={['decel']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Change" attr="changeDecel" location={['changeDecel']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Result" attr="ratio" location={['ratio']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Change" attr="changeRatio" location={['changeRatio']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Arm" attr="armFeels" location={['armFeels']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Body" attr="bodyFeels" location={['bodyFeels']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Sleep" attr="sleepQuality" location={['sleepQuality']} sortFunction={toggleSortNumber} />
        </tr>
      </thead>
      <tbody onClick={() => useSort('')}>
        {table.length > 0 && (
          <TeamAverageRow>
            <td>Avg</td>
            <td>{loading && <Loader width="20px" color="#B1D6FF" />}</td>
            <td>{numberColumnFormatter(average.total)}</td>
            <td>
              {numberColumnFormatter(average.changeTotal)}
              {changeStatus(average.changeTotal)}
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(average.accel)}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(average.changeAccel)}
              {changeStatus(average.changeAccel)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(average.decel)}</td>
            <td>
              {numberColumnFormatter(average.changeDecel)}
              {changeStatus(average.changeDecel)}
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(average.ratio, {digits: 2})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(average.changeRatio, {digits: 2})}
              {changeStatus(average.changeRatio)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(average.armFeels)}</td>
            <td>{numberColumnFormatter(average.bodyFeels)}</td>
            <td>{numberColumnFormatter(average.sleepQuality)}</td>
          </TeamAverageRow>
        )}
        {table.length > 0 ? (
          table.map((item, index) => {
            return (
              <TableItem
                key={item._id}
                item={item}
                useLoading={useLoading}
                fatigueZone={fatigueZone}
                changeStatus={changeStatus}
                DownloadReport={DownloadReport}
                hideExam={hideExam}
              />
            );
          })
        ) : (
          <tr>
            <td colSpan={25}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};

const TableItem = ({item, useLoading, fatigueZone, changeStatus, DownloadReport, hideExam}) => {
  const [hide, setHide] = useState<Boolean>(item.excludeFromExamAvg);
  const [opacity, setOpacity] = useState<string>(item.excludeFromExamAvg ? '0.5' : '1');

  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    hide ? setOpacity('0.5') : setOpacity('1');
    hideExam(item._id, hide, 'arm-primer');
    useLoading(true);
  }, [hide]);

  function handleDate(date) {
    return date ? new Date(date).toLocaleDateString('en-US') : '-';
  }

  return (
    <tr style={{opacity: opacity}}>
      <td className="white pointer" onClick={() => setHide(!hide)}>
        {hide ? <img src={HideOn} alt="hideOn" /> : <img src={HideOff} alt="hideOn" />}
      </td>
      <td className="white">{handleDate(item.date)}</td>
      <td className="white">
        {numberColumnFormatter(item.total)}
        {fatigueZone && getFatigueZoneBullet(item.armReadinessTotal)}
      </td>
      <td className="white">
        {numberColumnFormatter(item.changeTotal)}
        {changeStatus(item.changeTotal)}
      </td>
      <ShadowTableColumn>
        {numberColumnFormatter(item.accel)}
        {fatigueZone && getFatigueZoneBullet(item.armReadinessAccel)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item.changeAccel)}
        {changeStatus(item.changeAccel)}
      </ShadowTableColumn>
      <td className="white">
        {numberColumnFormatter(item.decel)}
        {fatigueZone && getFatigueZoneBullet(item.armReadinessDecel)}
      </td>
      <td className="white">
        {numberColumnFormatter(item.changeDecel)}
        {changeStatus(item.changeDecel)}
      </td>
      <ShadowTableColumn>{numberColumnFormatter(item.ratio, {digits: 2})}</ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item.changeRatio, {digits: 2})}
        {changeStatus(item.changeRatio)}
      </ShadowTableColumn>
      <td className="white">{numberColumnFormatter(item.armFeels, {digits: 0})}</td>
      <td className="white">{numberColumnFormatter(item.bodyFeels, {digits: 0})}</td>
      <td className="white">{numberColumnFormatter(item.sleepQuality, {digits: 0})}</td>
    </tr>
  );
};
